<template>
  <div id="app">
    <router-view  />
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    //可视化首次展示
    $route(to, from) {
      sessionStorage.setItem("nowIndex", JSON.stringify(0));
    }
    // $route(to, from) {
    //   if (to.path === "/pharma/chemicalMajor" && from.path === "/index") {
    //     sessionStorage.setItem("nowIndex", JSON.stringify(0));
    //   } else {
    //     sessionStorage.setItem("nowIndex", JSON.stringify(0));
    //   }
    // }
    
  }
};
</script>

<style lang='less'>
html,
body,
#app {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue